import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import { Map } from 'immutable'
import { getBoundActions } from '../../../actions/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import { AI_PERSONA_SELECTED_GA4_EVENT } from '../../../services/event-tracking/index'
import {
  PERSONALITY_ARCHITECT_ID,
  PERSONALITY_SAGE_ID,
} from '../../../services/oracle/index'
import { selectDefaultOraclePersonalityId } from '../../../services/feature-tracking/selectors'
import { Radio } from '../../FormInput.v2/index'
import { usePostHogEvent } from '../../PostHog/index'

const AIPersonalitySettings = (props) => {
  const {
    defaultOraclePersonalityId,
    staticText,
    setFeatureTrackingDataPersistent,
    setAiGa4Event,
  } = props

  const trackPersonaSelected = usePostHogEvent('ai_persona_selected')

  const onAIPersonalitySettingsChange = (value) => {
    const personalityId = Number(value)

    setFeatureTrackingDataPersistent({
      data: Map({ defaultOraclePersonalityId: personalityId }),
    })

    // GA4 events
    setAiGa4Event(AI_PERSONA_SELECTED_GA4_EVENT.mergeDeep({
      ui_element: 'Radio Buttons',
      ui_location: 'Settings',
      ai_persona: personalityId,
    }))
    trackPersonaSelected(String(personalityId))
  }

  return (
    <div className="my-account-settings-V2__display-settings-controls">
      <div className="my-account-settings-V2__display-settings-text-container">
        <div className="my-account-settings-V2__display-settings-title">
          { staticText.getIn(['data', 'aiPersonality']) }
        </div>
        <div className="my-account-settings-V2__display-settings-text">
          {staticText.getIn(['data', 'aiPersonalityDesc'])}
        </div>
      </div>
      <div className="my-account-settings-V2__display-settings-radio-group">
        <Radio
          className="my-account-settings-V2__display-settings-radio"
          label="Architect+"
          value={PERSONALITY_ARCHITECT_ID}
          name="personalityId"
          checked={defaultOraclePersonalityId === PERSONALITY_ARCHITECT_ID}
          onChange={() => onAIPersonalitySettingsChange(PERSONALITY_ARCHITECT_ID)}
        />
        <Radio
          className="my-account-settings-V2__display-settings-radio"
          label="Gaia Sage"
          value={PERSONALITY_SAGE_ID}
          name="personalityId"
          checked={defaultOraclePersonalityId === PERSONALITY_SAGE_ID}
          onChange={() => onAIPersonalitySettingsChange(PERSONALITY_SAGE_ID)}
        />
      </div>
    </div>
  )
}

AIPersonalitySettings.propTypes = {
  defaultOraclePersonalityId: PropTypes.number,
  setFeatureTrackingDataPersistent: PropTypes.func.isRequired,
}

export default compose(
  connectRedux(
    (state) => {
      return {
        defaultOraclePersonalityId: Number(selectDefaultOraclePersonalityId(state)),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setAiGa4Event: actions.eventTracking.setAiGa4Event,
        setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
      }
    },
  ),
  connectStaticText({ storeKey: 'myAccountSettingsV2' }),
)(AIPersonalitySettings)
